export const LOADING_WORKFLOWBLOCK_TASKS_LISTS = 'LOADING_WORKFLOWBLOCK_TASKS_LISTS';
export const LOADING_WORKFLOWBLOCK_TASK_LIST = 'LOADING_WORKFLOWBLOCK_TASK_LIST';
export const SAVE_LOADING_WORKFLOWBLOCK_TASK_LIST = 'SAVE_LOADING_WORKFLOWBLOCK_TASK_LIST';
export const GET_WORKFLOWBLOCK_TASKS_LIST = 'GET_WORKFLOWBLOCK_TASKS_LIST';
export const GET_WORKFLOWBLOCK_TASK_LIST = 'GET_WORKFLOWBLOCK_TASK_LIST';
export const WORKFLOWBLOCK_TASK_LIST_FAIL = 'WORKFLOWBLOCK_TASK_LIST_FAIL';
export const WORKFLOWBLOCK_TASK_LIST_FORM_FAIL = 'WORKFLOWBLOCK_TASK_LIST_FORM_FAIL';
export const SAVE_LOADING_WORKFLOW_TASK_LIST_POSITION = 'SAVE_LOADING_WORKFLOW_TASK_LIST_POSITION';
